export default "__VITE_ASSET__1662e866__"